import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'findOptionTextPipe'})
export class FindOptionTextPipe implements PipeTransform {

  transform(options: any[], id: string): unknown {
    if (options) {
      const foundField = options.find(Option => (!Option.id && (!id || id.length === 0)) || Option.id === id + ''
        || (Option.text && Option.text === id));
      // console.log("----> foundField  " + field + " " + id + " " + JSON.stringify(foundField));
      if (foundField) {
        return foundField.text;
      }
    }
    return id;
  }

}
